import { queryClient } from "@/utils/api";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import z from "zod";

const historyStateSchema = z
  .object({
    returnTo: z.object({
      to: z.string(),
      search: z.record(z.string(), z.any()).optional(),
    }),
  })
  .optional()
  .catch(undefined);

const parseHistoryState = (v: z.infer<typeof historyStateSchema>) =>
  historyStateSchema.parse(v);

export const Route = createFileRoute(
  "/_dashboard/campaigns/$id/(edit)/start-campaign",
)({
  staticData: {
    crumb: "Start kampagne",
    meta: {
      title: "Start kampagne",
    },
  },
  beforeLoad: async ({ context, location }) => {
    const redirectBack = () =>
      redirect({
        from: Route.fullPath,
        to: "..",
        replace: true,
      });

    const historyState = parseHistoryState(
      location.state.routeStates?.[Route.id],
    );

    if (!historyState) throw redirectBack();

    const campaign = await queryClient.ensureQueryData(
      context.campaignQueryOptions,
    );

    if (campaign.status === "Active" || campaign.status === "Archived")
      throw redirectBack();

    return {
      parseHistoryState,
      useHistoryState: () => historyState,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
